import * as React from 'react';
import * as moment from 'moment';
import { IFindForTransferResponse } from '@nkr/store/index';
import { ICenterBase, IConnectToDonorStatus, IDonorConnect, IListItem, IUser } from '@nkr/models/index';
import { AuthRole, ConnectToDonorMilestone } from '@nkr/enums/index';
import { ICounselor, milestones } from './models';
import { Alert, Button, Col, ControlLabel, FormControl, Glyphicon, Label, Panel, Row, Well } from 'react-bootstrap';
import { FormGroupWrapper, ViewWrapper } from './styles';
import Log from './log';
import WorkupSurvey from './milestones/workup-survey';
import PreOpSurvey from './milestones/preop-survey';
import PostDonationSurvey from './milestones/post-donation-survey';
import PostDonation30DaysSurvey from './milestones/post-donation-30-days-survey';
import TransferDonor from './transfer-donor';
import PreferredDonationType from './preferred-donation-type-renderer';
import CenterStatistics from './center-statistics';
import ConnectToDonorStatus from './connect-to-donor-status';
import { GambitType } from '@nkr/models/gambit-type';
import DonorMentorSendEmail from './donor-mentor-send-email';

interface IProps {
    isOpen: boolean,
    data: IDonorConnect,
    user: IUser,
    statusList: IConnectToDonorStatus[],
    mentorEducationChoiceList: IListItem[],
    actionList: IListItem[],
    userList: ICounselor[],
    centerList: ICenterBase[],
    closeLoopDonationTypes: IListItem[],
    donationDetailsSaved: boolean,
    onStatusChange: (id: number, statusId: number) => void,
    onMentorEducationChoiceChange: (id: number, statusId: number) => void,
    onCounselorChange: (id: number, userId: number) => void,
    onNextFollowUpDateChange: (date: string) => void,
    onDonationDateChange: (date: string) => void,
    onDonationCenterChange: (centerId: string) => void,
    onDonationTypeChange: (type: string) => void,
    onDonationUpdateClick: (id: number) => void,
    onUpdateNextFollowUpDate: (id: number) => void,
    onRemoveNextFollowUpDate: (id: number) => void,
    onSaveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string, isPinned: boolean) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void,
    onNextMilestone: (id: number, milestone: ConnectToDonorMilestone) => void,
    onSubmitWorkupSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => void,
    onSubmitPreOpSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => void,
    onSubmitPostDonationSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => void,
    onSubmitPostDonation30DaysSurvey: (id: number, surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => void,
    onFindForTransfer: (centerId: number, email: string, birthDate: string) => Promise<IFindForTransferResponse>,
    onRequestTransfer: (id: number, centerId: number) => void,
    onCompleteTransfer: (id: number, existingId: number) => void,
    onDownloadCenterContacts: (centerId: number) => void,
    onHoldStatusReasonChange: (id: number, onHoldStatusReason: string) => void,
    onMentorEmailSent: () => void,
}

interface IState {
    selectedStatusId: number,
    showWorkupSurvey: boolean,
    showPreOpSurvey: boolean,
    showPostDonationSurvey: boolean,
    showPostDonation30DaysSurvey: boolean,
    showTransferDonor: boolean,
    showEmailForm: boolean
}

class ViewRegistration extends React.Component<IProps, IState> {
    readonly state: IState = {
        selectedStatusId: this.props.data.connectToDonorStatusId,
        showWorkupSurvey: false,
        showPreOpSurvey: false,
        showPostDonationSurvey: false,
        showPostDonation30DaysSurvey: false,
        showTransferDonor: false,
        showEmailForm: false,
    }

    handleSaveLogEntry = (id: number, dashRegistrationId: number, actionTaken: number, comments: string, isPinned: boolean) => {
        this.props.onSaveLogEntry(id, dashRegistrationId, actionTaken, comments, isPinned);
    }

    handleNextFollowUpDateChange = (e: any) => {
        this.props.onNextFollowUpDateChange(e.currentTarget.value);
    }

    handleDonationDateChange = (e: any) => {
        this.props.onDonationDateChange(e.currentTarget.value);
    }

    handleDonationCenterChange = (e: any) => {
        this.props.onDonationCenterChange(e.currentTarget.value);
    }

    handleDonationTypeChange = (e: any) => {
        this.props.onDonationTypeChange(e.currentTarget.value);
    }

    handleDonationUpdateClick = (id: number) => {
        this.props.onDonationUpdateClick(id);
    }

    handleNextMilestone = () => {
        if (this.props.data.connectToDonorMilestoneCanProgress) {
            var mileStoneValid = this.validateMilestone();

            if (mileStoneValid) {
                this.props.onNextMilestone(this.props.data.id, this.props.data.connectToDonorNextMilestone);
            }
        }

        switch (this.props.data.connectToDonorNextMilestone) {
            case ConnectToDonorMilestone.Contacted:
                break;

            case ConnectToDonorMilestone.WorkupSurvey:
                this.setState({
                    showWorkupSurvey: true
                });

                break;

            case ConnectToDonorMilestone.PreOpSurvey:
                this.setState({
                    showPreOpSurvey: true
                });

                break;

            case ConnectToDonorMilestone.PostDonation3DaysSurvey:
                this.setState({
                    showPostDonationSurvey: true
                });

                break;

            case ConnectToDonorMilestone.PostDonation30DaysSurvey:
                this.setState({
                    showPostDonation30DaysSurvey: true
                });

                break;
        }
    }

    handleWorkupSurveySubmit = (treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showWorkupSurvey: false
        }, () => {
            this.props.onSubmitWorkupSurvey(this.props.data.id, treatment, convenience, facility, commendation, improvement, completedDate);
        });
    }

    handlePreOpSurveySubmit = (treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showPreOpSurvey: false
        }, () => {
            this.props.onSubmitPreOpSurvey(this.props.data.id, treatment, convenience, facility, commendation, improvement, completedDate);
        });
    }

    handlePostDonationSurveySubmit = (treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showPostDonationSurvey: false
        }, () => {
            this.props.onSubmitPostDonationSurvey(this.props.data.id, treatment, convenience, facility, commendation, improvement, completedDate);
        });
    }

    handlePostDonation30DaysSurveySubmit = (surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showPostDonation30DaysSurvey: false
        }, () => {
            this.props.onSubmitPostDonation30DaysSurvey(this.props.data.id, surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate);
        });
    }

    handleShowTransferDonor = () => {
        this.setState({
            showTransferDonor: true
        });
    }

    handleCancelTransferDonor = () => {
        this.setState({
            showTransferDonor: false
        });
    }

    handleRequestTransfer = (centerId: number) => {
        this.setState({
            showTransferDonor: false
        }, () => {
            this.props.onRequestTransfer(this.props.data.id, centerId);
        });
    }

    handleCompleteTransfer = (existingId: number) => {
        this.setState({
            showTransferDonor: false
        }, () => {
            this.props.onCompleteTransfer(this.props.data.id, existingId);
        });
    }

    handleHideSendEmail = () => {
        this.setState({
            showEmailForm: false
        });
    }

    handleToggleSendEmail = () => {
        if (!this.props.data.canSendMentorEmail) {
            return;
        }

        this.setState(prevState => ({
            showEmailForm: !prevState.showEmailForm
        }));
    }

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.isOpen && !this.props.isOpen && this.state.showEmailForm) {
            this.setState({
                showEmailForm: false
            });
        }
    }

    validateMilestone = () => {
        var canProgress = false;

        switch (this.props.data.connectToDonorNextMilestone) {
            case ConnectToDonorMilestone.Contacted:
                if (confirm('Was candidate successfully contacted?')) {
                    canProgress = true;
                }
                break;
            default:
                canProgress = false;
                break;
        }

        return canProgress;
    }

    getAlertStyle = (date: string, isValid: boolean) => {
        let nextFollowUpDate = moment(date);

        let nextFollowUpDateIsPast = isValid ? nextFollowUpDate.isBefore(moment(), 'day') : false;
        let nextFollowUpDateIsToday = isValid ? nextFollowUpDate.isSame(moment(), 'day') : false;

        if (nextFollowUpDateIsPast) {
            return { level: 3, style: 'danger' };
        }

        if (nextFollowUpDateIsToday) {
            return { level: 2, style: 'warning' };
        }

        return null;
    }

    getAge = () => {
        let age = '';

        if (moment(this.props.data.birthDate).isValid()) {
            let today = moment();
            let years = today.diff(this.props.data.birthDate, 'years');

            if (isNaN(years) || years < 18 || years > 100) {
                age = '';
            } else {
                age = years.toString();
            }
        }

        return age;
    }


    isNullOrEmpty = (str) => {
        return str === null || str === undefined || str === '';
    }

    renderRecipientCenterInformation = () => {        
        if (this.isNullOrEmpty(this.props.data.recipientCenterAlias)) {
            return 'N/A';
        }

        if (this.props.data.recipientCenterStats == null) {
            return `${this.props.data.recipientCenterAlias} (Not a Member Center)`;
        }

        if (this.props.data.recipientCenterStats != null) {
            return (
                <CenterStatistics
                    data={this.props.data.recipientCenterStats}
                    onDownloadCenterContacts={this.props.onDownloadCenterContacts}
                    contactData={this.props.data.recipientCenterContacts}
                    centerId={this.props.data.recipientCenterId}
                    isAdmin={true}
                    placement='left'
                    width='25%'
                    buttonText={this.props.data.recipientCenterAlias} 
                />
            )
        }
    }

    hasAccessToEmailForm = (): boolean => {
        const approvedAuthRoles = [AuthRole.DonorConnectAccessAll, AuthRole.DonorConnectAccessAssigned, AuthRole.IsSuperAdmin];

        if (this.props.user.groupId == 2 && this.props.data.connectToDonorGroupId == 2) {
            return true;
        }

        return this.props.user.roles.find(x => approvedAuthRoles.indexOf(x.id) >= 0 && x.entityTypeId == 2) != null
            && this.props.data.connectToDonorGroupId == 2;
    }

    getMentorEmailBlockedReason = (): string => {
        return this.props.data.mentorEmailBlockedReason || "This donor is not eligible for donor mentor email communication.";
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const nextFollowUp = this.props.data.connectToDonorNextFollowUpDate ? moment(this.props.data.connectToDonorNextFollowUpDate).format("YYYY-MM-DD") : "";
        const disableNextFollowUpDateSaveButton = moment(nextFollowUp, 'YYYY-MM-DD', true).isValid() == false;
        const alertStyle = this.getAlertStyle(nextFollowUp, !disableNextFollowUpDateSaveButton);
        const currentMilestone = milestones.find(x => x.milestone == this.props.data.connectToDonorMilestone);
        const nextMilestone = milestones.find(x => x.milestone == this.props.data.connectToDonorNextMilestone);
        const canTransfer = this.props.user.roles.find(x => x.id == AuthRole.DonorConnectAccessAll) != null && this.props.data.centerAlias != null;
        const allowMentorChange = this.props.user.roles.find(x => x.id == AuthRole.DonorConnectAccessAll) != null;
        const hasMentorEmailAccess = this.hasAccessToEmailForm();
        const canUseMentorEmailForm = hasMentorEmailAccess && this.props.data.canSendMentorEmail;
        const today = moment();       

        if (currentMilestone == null) {
            return null;
        }

        const lgLabel = 4;
        const lgData = 8;

        const donated = this.props.statusList.find(s => s.id === this.props.data.connectToDonorStatusId).description.includes('Donated');
        const donationDateInvalid = this.props.data.mentorDonationDate == ''
            || this.props.data.mentorDonationDate == null
            || moment(this.props.data.mentorDonationDate, 'MM/DD/YYYY', true).isAfter(today, 'day');
        const donationTypeInvalid = this.props.data.mentorDonationTypeId == '' || this.props.data.mentorDonationTypeId == null || this.props.data.mentorDonationTypeId == 0 || this.props.data.mentorDonationTypeId == '0';
        const donationCenterInvalid = !this.props.data.mentorDonationCenterId;
        const disableDonationDetailsSaveButton = donationDateInvalid || donationTypeInvalid || donationCenterInvalid;

        const age = this.getAge();

        return (
             <ViewWrapper> 
                <div className='modal-container'>
                    <Alert bsStyle='info' style={{ marginBottom: 10 }}>
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Registration #:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.id}</Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Registration Date:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.registrationDate}</Col>
                        </Row>
                        
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>PWL Process:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.pwlProcess ? this.props.data.pwlProcess : 'N/A'}</Col>
                        </Row>
                        

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Screening Date:</Col>
                            <Col xs={12} lg={lgData}>{this.isNullOrEmpty(this.props.data.screeningCompleteDate) ? 'N/A' : this.props.data.screeningCompleteDate}</Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Referral Date:</Col>
                            <Col xs={12} lg={lgData}>{this.isNullOrEmpty(this.props.data.intakeCompleteDate) ? 'N/A' : this.props.data.intakeCompleteDate}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Entry Source:</Col>
                            <Col xs={12} lg={lgData}>
                                {this.props.data.entryReferrerSrcCode == 'nutcracker'
                                    ? <label className='label label-warning' style={{ fontSize: '11px' }}>{this.props.data.entrySource}</label>
                                    : <>{this.props.data.entrySource}</>
                                }
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Recipient Center:</Col>
                            <Col xs={12} lg={lgData}>
                                {this.renderRecipientCenterInformation()}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Name:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.firstName} {this.props.data.lastName}</Col>
                        </Row>

                        {this.props.data.preferredName != null && (
                            <Row>
                                <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Preferred/Chosen Name:</Col>
                                <Col xs={12} lg={lgData}>{this.props.data.preferredName}</Col>
                            </Row>
                        )}

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Age:</Col>
                            <Col xs={12} lg={lgData}>{age}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Gender:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.gender ? this.props.data.gender : 'N/A'}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Email:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.email} &nbsp;
                                {this.props.data.mobileAuthCode == null || this.props.data.mobileAuthCode == '' ? (
                                    <label className='label label-success' style={{ fontSize: '11px' }}>
                                        <span className='glyphicon glyphicon-check' ></span>
                                    </label>
                                ) : null}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Mobile Number:</Col>
                            <Col xs={12} lg={lgData}>
                                {this.props.data.mobileAuthCode !== '' && this.props.data.mobileAuthCode !== null ? (
                                    <>
                                        {this.props.data.mobileNumber} &nbsp;
                                        <label className='label label-success' style={{ fontSize: '11px' }}>
                                            <span className='glyphicon glyphicon-check' ></span>
                                        </label>
                                    </>
                                ) : (
                                    <Label>not specified</Label>
                                )}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Phone Number(s):</Col>
                            <Col xs={12} lg={lgData}>
                                {this.props.data.phoneNumber != '' ?
                                    <>
                                        <div>{this.props.data.phoneNumber}</div>
                                        {this.props.data.phoneNumberSecondary != '' && (
                                            <div>{this.props.data.phoneNumberSecondary}</div>
                                        )}
                                    </>
                                    :
                                    <>--</>
                                }
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Location:</Col>
                            <Col xs={12} lg={lgData}>
                                {this.props.data.city != '' && this.props.data.state != '' && this.props.data.postalCode != '' ?
                                    <>{this.props.data.city}, {this.props.data.state} {this.props.data.postalCode}</>
                                    :
                                    <>--</>
                                }
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Postal Code:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.postalCode != '' ? this.props.data.postalCode : <Label>not specified</Label>}</Col>
                        </Row> */}
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Timezone:</Col>
                            <Col xs={12} lg={lgData}>{this.props.data.timezone != '' ? this.props.data.timezone : <Label>postal code not specified</Label>}</Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>
                                Selected Center:
                            </Col>
                            <Col xs={12} lg={lgData}>
                                {this.props.data.centerAlias != null && (
                                    <CenterStatistics
                                        data={this.props.data.centerStats}
                                        onDownloadCenterContacts={this.props.onDownloadCenterContacts}
                                        contactData={this.props.data.centerContacts}
                                        centerId={this.props.data.centerId}
                                        isAdmin={true}
                                        placement='left'
                                        width='25%'
                                        buttonText={this.props.data.centerAlias} />
                                )}

                                {this.props.data.centerAlias == null && (
                                    <>- pending selection -&nbsp;</>
                                )}

                                {canTransfer && (
                                    <Button bsSize='xs' onClick={this.handleShowTransferDonor}>Transfer Donor</Button>
                                )}
                            </Col>
                        </Row>
                         <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Post Txp MS:</Col>
                            <Col xs={12} lg={lgData}><Label>{this.props.data.postTxp == true? 'Yes' : ''}</Label></Col>
                        </Row>
                         <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Receivced Voucher:</Col>
                            <Col xs={12} lg={lgData}><Label>{this.props.data.receivedVoucher == true? 'Yes' : ''}</Label></Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>Preferred Donation Type:</Col>
                            <Col xs={12} lg={lgData}>
                                <PreferredDonationType
                                    voucherEducationChoiceId={this.props.data.voucherEducationChoiceId}
                                    donorSituationId={this.props.data.donorSituationId} />
                            </Col>
                        </Row>
                    </Alert>

                    {this.props.user.group.isSuper && (
                        <Row>
                            <Col xs={12} lg={lgLabel} style={{ fontWeight: 500 }}>
                                <a href={`/center/${this.props.data.centerId}/donors/donor-intake/diagnostics/${this.props.data.id}`}>Edit Diagnostics</a>
                            </Col>
                        </Row>
                    )}
                    
                    <Panel>
                        <Panel.Body>
                            <FormGroupWrapper>
                                <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Status:</Col>
                                <Col xs={12} lg={lgData}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.props.data.connectToDonorStatusId}
                                        onChange={
                                            (e: React.FormEvent<FormControl & HTMLSelectElement>) => { 
                                                let value = Number(e.currentTarget.value);

                                                this.props.onStatusChange(this.props.data.id, value)
                                            }}
                                    >
                                        {this.props.statusList.map(item =>
                                            <option value={item.id}>{item.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroupWrapper>

                            {this.props.data.connectToDonorStatusId == 11 && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>On Hold Reason:</Col>
                                    <Col xs={12} lg={lgData}>
                                        <ConnectToDonorStatus
                                            id={this.props.data.id}
                                            gambitData={this.props.data.dashGambitData}
                                            gambitType={GambitType.DonotIntakeOnHoldReason_ConnectToDonorStatus}
                                            showControlLabel={false}
                                            onTextChange={this.props.onHoldStatusReasonChange}
                                        />
                                    </Col>
                                </FormGroupWrapper>
                            )}

                            {donated && (
                                <Well bsSize='sm' style={{ marginTop: 10 }}>
                                    <FormGroupWrapper validationState={this.props.data.mentorDonationCenterId > 0 ? null : 'error'}>
                                        <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Donation Center:</Col>
                                        <Col xs={12} lg={lgData}>
                                            {this.props.donationDetailsSaved ? (
                                                <div>
                                                    {this.props.centerList.find(center => center.id == this.props.data.mentorDonationCenterId)?.alias || ''}
                                                    {this.props.centerList.find(center => center.id == this.props.data.mentorDonationCenterId && !center.isMemberCenter) ? ' (non-member)' : ''}
                                                </div>
                                            ) : (
                                                <FormControl
                                                    componentClass='select'
                                                    value={this.props.data.mentorDonationCenterId || 0}
                                                    onChange={this.handleDonationCenterChange}
                                                >
                                                    <option value={0}>Please Select</option>
                                                    {this.props.centerList.map(center =>
                                                        <option key={center.id} value={center.id}>{center.alias}{!center.isMemberCenter ? ' (non-member)' : ''}</option>
                                                    )}
                                                </FormControl>
                                            )}
                                        </Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper validationState={donationDateInvalid ? 'error' : null}>
                                        <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Donation Date:</Col>
                                        <Col xs={12} lg={lgData}>
                                            {this.props.donationDetailsSaved ? (
                                                <div>{this.props.data.mentorDonationDate}</div>
                                            ) : (
                                                <>
                                                    <div style={{ marginRight: 5 }}>
                                                        <FormControl
                                                            type='date'
                                                            max={today.format('YYYY-MM-DD')}
                                                            value={this.props.data.mentorDonationDate && moment(this.props.data.mentorDonationDate, 'MM/DD/YYYY', true).isValid()
                                                                ? moment(this.props.data.mentorDonationDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
                                                                : ''}
                                                            onFocus={(e: React.FocusEvent<FormControl & HTMLInputElement>) => (e.currentTarget as any).showPicker?.()}
                                                            onClick={(e: React.MouseEvent<FormControl & HTMLInputElement>) => (e.currentTarget as any).showPicker?.()}
                                                            onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) =>
                                                                this.props.onDonationDateChange(
                                                                    e.currentTarget.value
                                                                        ? moment(e.currentTarget.value, 'YYYY-MM-DD').format('MM/DD/YYYY')
                                                                        : ''
                                                                )}
                                                        />
                                                    </div>
                                                    {moment(this.props.data.mentorDonationDate, 'MM/DD/YYYY', true).isAfter(today, 'day') && (
                                                        <Row style={{ marginBottom: 10 }}>
                                                            <Col xs={12} lg={lgData} >
                                                                <Label bsStyle='danger'>
                                                                    <>Donation date cannot be in the future.</>
                                                                </Label>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </>
                                            )}
                                        </Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper validationState={donationTypeInvalid ? 'error' : null}>
                                        <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Donation Type:</Col>
                                        <Col xs={12} lg={lgData}>
                                            {this.props.donationDetailsSaved ? (
                                                <div>{this.props.closeLoopDonationTypes.find(item => item.id == this.props.data.mentorDonationTypeId)?.description || ''}</div>
                                            ) : (
                                                <FormControl
                                                    componentClass='select'
                                                    value={this.props.data.mentorDonationTypeId}
                                                    onChange={this.handleDonationTypeChange}
                                                >
                                                    <option value=''>Please Select</option>
                                                    {this.props.closeLoopDonationTypes.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            )}
                                        </Col>
                                    </FormGroupWrapper>

                                    {!this.props.donationDetailsSaved && (
                                        <FormGroupWrapper validationState={disableDonationDetailsSaveButton ? 'error' : null}>
                                            <Col xs={12} lg={lgData} lgOffset={lgLabel}>
                                                <Button bsStyle='primary' bsSize='sm' title='Save Donation Details' disabled={disableDonationDetailsSaveButton} onClick={() => this.handleDonationUpdateClick(this.props.data.id)}>
                                                    Save Donation Details
                                                </Button>
                                            </Col>
                                        </FormGroupWrapper>
                                    )}
                                </Well>
                            )}

                            <FormGroupWrapper>
                                <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Assigned Mentor:</Col>
                                <Col xs={12} lg={lgData}>
                                    {allowMentorChange ?
                                        <FormControl
                                            componentClass='select'
                                            value={this.props.data.connectToDonorAssignedUserId}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onCounselorChange(this.props.data.id, parseInt(e.currentTarget.value))}
                                        >
                                            <option value={0}>- Not Assigned -</option>
                                            {this.props.userList.map(item =>
                                                <option key={'mentor-' + item.id} value={item.id}>{item.lastName}, {item.firstName}</option>
                                            )}
                                        </FormControl>
                                        :
                                        <FormControl.Static style={{ border: '1px solid #ccc', borderRadius: 4, padding: '6px 12px', backgroundColor: '#eee' }}>
                                            {this.props.data.connectToDonorAssigndUser != null && (
                                                <>{this.props.data.connectToDonorAssigndUser.firstName} {this.props.data.connectToDonorAssigndUser.lastName}</>
                                            )}
                                        </FormControl.Static>
                                    }
                                </Col>
                            </FormGroupWrapper>

                            {hasMentorEmailAccess && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Mentor Email:</Col>
                                    <Col xs={12} lg={lgData}>
                                        <Panel className='mentor-email-panel' expanded={this.state.showEmailForm} onToggle={this.handleToggleSendEmail} style={{ marginBottom: 0 }}>
                                            <Panel.Heading>
                                                <Panel.Title toggle style={{fontSize: '14px'}}>
                                                    Mentor Email Form
                                                    <Glyphicon glyph={this.state.showEmailForm ? 'triangle-bottom' : 'triangle-right'} style={{ marginRight: '5', fontSize: '12px' }} />
                                                </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Body collapsible>
                                                {canUseMentorEmailForm && this.props.isOpen && (
                                                    <DonorMentorSendEmail
                                                        registrationId={this.props.data.id}
                                                        donorEmail={this.props.data.email}
                                                        donorFirstName={this.props.data.firstName}
                                                        mentorFullName={`${this.props.user.firstName ?? ""} ${this.props.user.lastName ?? ""}`.trim()}
                                                        canSendMentorEmail={this.props.data.canSendMentorEmail}
                                                        mentorEmailBlockedReason={this.props.data.mentorEmailBlockedReason}
                                                        onClose={this.handleHideSendEmail}
                                                        onSent={this.props.onMentorEmailSent}
                                                    />
                                                )}
                                            </Panel.Body>
                                        </Panel>
                                        {!this.props.data.canSendMentorEmail && (
                                            <Label bsStyle='warning' style={{ marginLeft: 10 }}>{this.getMentorEmailBlockedReason()}</Label>
                                        )}
                                    </Col>
                                </FormGroupWrapper>
                            )}

                            <FormGroupWrapper validationState={this.props.data.connectToDonorNextFollowUpDate == '' ? 'error' : null}>
                                <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Next Follow-Up Date:</Col>
                                <Col xs={12} lg={lgData}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>                        
                                        <FormControl
                                            type='date'
                                            id='nextFollowUpDate'
                                            name='nextFollowUpDate'
                                            value={nextFollowUp} 
                                            onChange={this.handleNextFollowUpDateChange}
                                        />
                            
                                        <div style={{ marginRight: 5 }}>
                                            <Button bsStyle='primary' bsSize='xs' disabled={disableNextFollowUpDateSaveButton} title='Save specified date' onClick={() => this.props.onUpdateNextFollowUpDate(this.props.data.id)}>
                                                <Glyphicon glyph='ok' />
                                            </Button>
                                        </div>

                                        {this.props.data.connectToDonorNextFollowUpDate == '' && (
                                            <Label bsStyle='danger' style={{ padding: '.3em .6em' }}>This is required</Label>
                                        )}
                                    </div>
                                </Col>
                            </FormGroupWrapper>

                            {alertStyle != null && (
                                <Row style={{ marginBottom: 10 }}>
                                    <Col xs={12} lg={lgData} lgOffset={lgLabel} style={{ paddingLeft: 20 }}>
                                        <Label bsStyle={alertStyle.style}>
                                            {alertStyle.level == 3 && (
                                                <>The next follow-up date is in the past</>
                                            )}

                                            {alertStyle.level == 2 && (
                                                <>The next follow-up date is today</>
                                            )}
                                        </Label>
                                    </Col>
                                </Row>
                            )}

                            <FormGroupWrapper style={{ marginBottom: 0, alignItems: nextMilestone.buttonLabel != '' ? 'flex-start' : 'center' }}>
                                <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Milestone:</Col>
                                <Col xs={12} lg={lgData}>
                                    {nextMilestone.buttonLabel != '' ?
                                        <>
                                            <div style={{ marginBottom: 5 }}>{currentMilestone.text}</div>
                                            <Button bsStyle='primary' bsSize='sm' style={{ whiteSpace: 'normal' }} onClick={this.handleNextMilestone}>{nextMilestone.buttonLabel}</Button>
                                        </>
                                        :
                                        <>{currentMilestone.text}</>
                                    }
                                </Col>
                            </FormGroupWrapper>

                            {currentMilestone.milestone >= ConnectToDonorMilestone.Contacted && (
                                <FormGroupWrapper style={{ marginTop: 5, marginBottom: 0 }}>
                                    <Col xs={12} lg={lgLabel} componentClass={ControlLabel}>Voucher Choice:</Col>
                                    <Col xs={12} lg={lgData}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.props.data.mentorEducationChoiceId}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onMentorEducationChoiceChange(this.props.data.id, parseInt(e.currentTarget.value))}
                                        >
                                            {this.props.mentorEducationChoiceList.map(item =>
                                                <option value={item.id}>{item.description}</option>
                                            )}
                                        </FormControl>
                                    </Col>
                                </FormGroupWrapper>
                            )}

                        </Panel.Body>
                    </Panel>

                    <Log
                        data={this.props.data}
                        statusList={this.props.statusList}
                        actionList={this.props.actionList}
                        userList={this.props.userList}
                        container={this}
                        isMobile={false}
                        onSaveLogEntry={this.handleSaveLogEntry}
                        onDeleteLogEntry={this.props.onDeleteLogEntry}
                    />
                </div>

                <WorkupSurvey
                    show={this.state.showWorkupSurvey}
                    container={this}
                    onSubmit={this.handleWorkupSurveySubmit}
                    onCancel={() => this.setState({ showWorkupSurvey: false })}
                />

                <PreOpSurvey
                    show={this.state.showPreOpSurvey}
                    container={this}
                    onSubmit={this.handlePreOpSurveySubmit}
                    onCancel={() => this.setState({ showPreOpSurvey: false })}
                />

                <PostDonationSurvey
                    show={this.state.showPostDonationSurvey}
                    container={this}
                    onSubmit={this.handlePostDonationSurveySubmit}
                    onCancel={() => this.setState({ showPostDonationSurvey: false })}
                />

                <PostDonation30DaysSurvey
                    show={this.state.showPostDonation30DaysSurvey}
                    container={this}
                    onSubmit={this.handlePostDonation30DaysSurveySubmit}
                    onCancel={() => this.setState({ showPostDonation30DaysSurvey: false })}
                />

                <TransferDonor
                    show={this.state.showTransferDonor}
                    name={this.props.data.firstName + ' ' + this.props.data.lastName}
                    email={this.props.data.email}
                    birthDate={this.props.data.birthDate}
                    currentCenterId={this.props.data.centerId}
                    currentCenterAlias={this.props.data.centerAlias}
                    centerList={this.props.centerList}
                    container={this}
                    onCheckRegistration={this.props.onFindForTransfer}
                    onRequestTransfer={this.handleRequestTransfer}
                    onCompleteTransfer={this.handleCompleteTransfer}
                    onCancel={this.handleCancelTransferDonor}
                />
            </ViewWrapper>
        );
    }
}

export default ViewRegistration;
